import moment from 'moment';
import ReactDOM from 'react-dom/client';
import { ReactNotifications } from 'react-notifications-component';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { storeFactory } from './reducers';

import 'handsontable/dist/handsontable.full.min.css';
import 'moment/locale/ru';
import 'react-notifications-component/dist/theme.css';
import { MEGAMARKET_1, OZON_1, SKLADS_WAREHOUSE, WB_1, YANDEX_1 } from './constans';
import './index.css';
import MainRouter from './routers';

import { registerAllModules } from 'handsontable/registry';

moment.locale('ru');

registerAllModules();

const initialState = {
  user: { auth: false },
  helpers: [],
  ui: { selectProvider: null, is_check_size: false, shipment_mode: 'Режим отгрузки', skladName: SKLADS_WAREHOUSE[0] },
  staff: [],
  price: {},
  version: null,
  orders: [],
  allOrders: [],
  /*  allOrdersGroped: [],*/
  collections: [],
  providers: [],
  mapMarkets: {
    ozon: {},
    ozon2: {},
    wb: {},
    goods: {},
    beru: {},
    beru2: {},
    bWhite: {},
  },
  packaging: [],
  ozon: {
    market: OZON_1,
    ids: [],
    byId: {},
  },
  wb: {
    market: WB_1,
    ids: [],
    byId: {},
  },
  yandex: {
    market: YANDEX_1,
    ids: [],
    byId: {},
  },
  kaspi: {
    ids: [],
    byId: {},
  },
  insales: {
    ids: [],
    byId: {},
  },
  sbermarket: {
    market: MEGAMARKET_1,
    ids: [],
    byId: {},
  },
  ozonOrders: {
    ids: [],
    byId: {},
    map: {},
  },
  wbOrders: {
    ids: [],
    byId: {},
    map: {},
  },
  /*  commisson: {},*/

  postings: {
    ids: [],
    byIds: {},
    map: {},
  },
};

const store = storeFactory(initialState);
export default store

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ReactNotifications />
      <MainRouter />
    </BrowserRouter>
  </Provider>,
);


